module.exports = __webpack_public_path__ + "static/media/court-tennis.fb656f43.jpg";